var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDog209(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#f9f7e1;stroke:#333;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dog_209"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("path", {
    id: "_209",
    "data-name": 209,
    className: "cls-2",
    d: "M66.91,91.4c17.37-2.12,29.18-22.81,31-39.79.46-4.29,2.53-23.61-11.37-35.15-7.29-6-19.48-10.38-28.95-6.2-6.51,2.88-8,9.55-12.65,14.43-11.55,12-33.1.41-41.62,18.73C0,50.55,1.6,58.94,6.58,64.88c6.29,7.5,13.16,5.73,21.37,8.29,7.38,2.29,11,9.14,17.15,13.11A34,34,0,0,0,66.91,91.4Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDog209);
export default __webpack_public_path__ + "static/media/dog_209.11e191ec93cb5f9f3cf9e838705d822f.svg";
export { ForwardRef as ReactComponent };